export class CustomPaletteProvider {
    // @ts-expect-error
    constructor(palette, create, elementFactory, translate) {
        palette.registerProvider(this);

        this.create = create;
        this.elementFactory = elementFactory;
        this.translate = translate;
    }

    /**
     * @param {any} element
     */
    getPaletteEntries(element) {

        const {
            create,
            elementFactory,
            translate
        } = this;

        /**
         * @param {any} event
         */
        function createCollapsedSubProcess(event) {
            const shape = elementFactory.createShape({ type: 'bpmn:SubProcess' });

            create.start(event, shape);
        }

        return function (/** @type {{ [x: string]: any; }} */ entries) {
            if (process.env.REACT_APP_NON_FILTERED_BPMN_ELEMENTS === 'true') {
                return entries;
            }

            return {
                'hand-tool': entries['hand-tool'],
                'lasso-tool': entries['lasso-tool'],
                'global-connect-tool': entries['global-connect-tool'],
                'tool-separator': entries['tool-separator'],
                'create.start-event': entries['create.start-event'],
                'create.end-event': entries['create.end-event'],
                'create.exclusive-gateway': entries['create.exclusive-gateway'],
                'create.task': entries['create.task'],
                'create.subprocess-expanded': entries['create.subprocess-expanded'],
                'create.subprocess-collapsed': {
                    group: 'activity',
                    className: 'bpmn-icon-subprocess-collapsed',
                    title: translate('Create collapsed sub-process'),
                    action: {
                        dragstart: createCollapsedSubProcess,
                        click: createCollapsedSubProcess,
                    },
                },
            };
        };
    }
}

CustomPaletteProvider.$inject = ['palette', 'create', 'elementFactory', 'translate'];
